import React, { useRef } from 'react';

const SIZE = 96;
const R = SIZE / 2;

// A color-grading wheel: hue/sat pad + luma slider. value = {h,s,l}.
// h 0..360, s 0..100, l -100..100.
export default function ColorWheel({ label, value, onChange }) {
  const v = value || { h: 0, s: 0, l: 0 };
  const padRef = useRef(null);

  const setHueSat = (e) => {
    const rect = padRef.current.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width * SIZE - R;
    const y = (e.clientY - rect.top) / rect.height * SIZE - R;
    let h = (Math.atan2(y, x) * 180) / Math.PI;
    if (h < 0) h += 360;
    const s = Math.min(100, (Math.hypot(x, y) / R) * 100);
    onChange({ ...v, h: Math.round(h), s: Math.round(s) });
  };

  const onDown = (e) => {
    setHueSat(e);
    const move = (ev) => setHueSat(ev);
    const up = () => {
      window.removeEventListener('mousemove', move);
      window.removeEventListener('mouseup', up);
    };
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
  };

  const rad = (v.s / 100) * R;
  const ang = (v.h * Math.PI) / 180;
  const dotX = R + Math.cos(ang) * rad;
  const dotY = R + Math.sin(ang) * rad;

  return (
    <div className="cs-wheel">
      <div className="cs-wheel-label">{label}</div>
      <div
        ref={padRef}
        className="cs-wheel-pad"
        style={{ width: SIZE, height: SIZE }}
        onMouseDown={onDown}
        onDoubleClick={() => onChange({ h: 0, s: 0, l: 0 })}
      >
        <span className="cs-wheel-dot" style={{ left: dotX, top: dotY }} />
      </div>
      <input
        type="range"
        min="-100"
        max="100"
        value={v.l}
        onChange={(e) => onChange({ ...v, l: Number(e.target.value) })}
        className="cs-wheel-luma"
        title="Luminance"
      />
    </div>
  );
}
